var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsectScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.28 26.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.75px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "insect_screen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ikone"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.38,
    y: 13.28,
    width: 25.53,
    height: 12.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "0.38 13.76 0.38 0.38 25.91 0.38 25.91 13.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.04,
    y1: 6.83,
    x2: 0.24,
    y2: 6.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.17,
    y1: 3.6,
    x2: 0.38,
    y2: 3.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.04,
    y1: 10.05,
    x2: 0.24,
    y2: 10.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.27,
    y1: 13.27,
    x2: 13.27,
    y2: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.75,
    y1: 13.28,
    x2: 6.75,
    y2: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 19.8,
    y1: 13.27,
    x2: 19.8,
    y2: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.1,
    y1: 13.28,
    x2: 10.1,
    y2: 0.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.4,
    y1: 13.27,
    x2: 3.4,
    y2: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.45,
    y1: 13.27,
    x2: 16.45,
    y2: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.98,
    y1: 13.27,
    x2: 22.98,
    y2: 0.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.04,
    y1: 1.99,
    x2: 0.24,
    y2: 1.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.24,
    y1: 5.21,
    x2: 0.44,
    y2: 5.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.11,
    y1: 11.67,
    x2: 0.31,
    y2: 11.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.24,
    y1: 8.44,
    x2: 0.44,
    y2: 8.44
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsectScreen);
export default __webpack_public_path__ + "static/media/insect_screen.417d18aba7ea8dc34dc3363a5916fbd9.svg";
export { ForwardRef as ReactComponent };